import { CalloutContentUpdatingEventArgs as CalloutContentUpdatingEventArgs_internal } from "./CalloutContentUpdatingEventArgs";
/**
 * Represents event arguments for updating content of callout layer
*/
var IgrCalloutContentUpdatingEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrCalloutContentUpdatingEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
        if (this._initializeAdapters) {
            this._initializeAdapters();
        }
    }
    IgrCalloutContentUpdatingEventArgs.prototype.createImplementation = function () {
        return new CalloutContentUpdatingEventArgs_internal();
    };
    Object.defineProperty(IgrCalloutContentUpdatingEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    IgrCalloutContentUpdatingEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrCalloutContentUpdatingEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
        if (this._initializeAdapters) {
            this._initializeAdapters();
        }
    };
    Object.defineProperty(IgrCalloutContentUpdatingEventArgs.prototype, "xValue", {
        /**
         * Gets data X-value assositated with callout layer
        */
        get: function () {
            return this.i.c;
        },
        set: function (v) {
            this.i.c = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutContentUpdatingEventArgs.prototype, "yValue", {
        /**
         * Gets data Y-value assositated with callout layer
        */
        get: function () {
            return this.i.d;
        },
        set: function (v) {
            this.i.d = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutContentUpdatingEventArgs.prototype, "item", {
        /**
         * Gets data item assositated with callout layer
        */
        get: function () {
            return this.i.item;
        },
        set: function (v) {
            this.i.item = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCalloutContentUpdatingEventArgs.prototype, "content", {
        /**
         * Gets or sets content displayed by callout layer
        */
        get: function () {
            return this.i.a;
        },
        set: function (v) {
            this.i.a = v;
        },
        enumerable: false,
        configurable: true
    });
    return IgrCalloutContentUpdatingEventArgs;
}());
export { IgrCalloutContentUpdatingEventArgs };
